/**
 * Provedor de tiles dos mapas (Mapa ao Vivo e modal do veículo).
 *
 * Histórico: começamos com OSM direto, que nos bloqueou por volume
 * ("Access blocked: tile usage policy"). Migramos para CartoDB, que
 * em 2026 passou a exigir chave e passou a servir tiles com a marca
 * d'água "API KEY REQUIRED" em vez de recusar — o mapa quebrava sem
 * dar erro. Agora usamos Stadia Maps.
 *
 * A chave é pública por natureza: tile de mapa é buscado pelo browser
 * do usuário, então ela aparece no bundle de qualquer jeito. A proteção
 * real é o allowlist de domínio configurado no painel da Stadia.
 *
 * Para trocar de chave sem recompilar o código, defina
 * VITE_MAP_TILE_KEY no build. Sem ela, cai na chave compartilhada
 * com o portal VGPL.
 */
const TILE_KEY =
  (import.meta.env.VITE_MAP_TILE_KEY as string | undefined) ??
  '4ee83160-8b73-4378-87d2-1bbfd13c312a';

export const TILE_URL =
  `https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png?api_key=${TILE_KEY}`;

export const TILE_ATTRIBUTION =
  '© Stadia Maps · © OpenMapTiles · © OpenStreetMap';

export const TILE_MAX_ZOOM = 20;
